export const frontmatter = {
    "draft": false,
    "title": "Guide: Campaigns",
    "description": "How to create and send campaigns in OnnIA: general data, templates, recipients, scheduling, and lifecycle states.",
    "sidebar_label": "Campaigns",
    "sidebar_group": "reference",
    "sidebar_order": 5
}

export const toc = [
    {
        "depth": 2,
        "id": "accessing-the-module",
        "value": "Accessing the module"
    },
    {
        "depth": 2,
        "id": "create-a-campaign",
        "value": "Create a campaign"
    },
    {
        "depth": 3,
        "id": "step-1-general-data",
        "value": "Step 1: General data"
    },
    {
        "depth": 3,
        "id": "step-2-templates-and-channels",
        "value": "Step 2: Templates and channels"
    },
    {
        "depth": 3,
        "id": "step-3-recipients-and-scheduling",
        "value": "Step 3: Recipients and scheduling"
    },
    {
        "depth": 2,
        "id": "campaign-states",
        "value": "Campaign states"
    },
    {
        "depth": 2,
        "id": "available-actions",
        "value": "Available actions"
    },
    {
        "depth": 2,
        "id": "recommendations",
        "value": "Recommendations"
    }
]